
import React from 'react';

interface ParticipantLocalBadgeProps {
  isLocal: boolean;
}

const ParticipantLocalBadge: React.FC<ParticipantLocalBadgeProps> = ({ isLocal }) => {
  if (!isLocal) {
    return null;
  }
  
  return (
    <div className="absolute top-2 left-2 z-30">
      <span className="text-xs bg-blue-500/20 text-blue-500 px-1.5 py-0.5 rounded-full">You</span>
    </div>
  );
};

export default ParticipantLocalBadge;
